// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardSelectorStage__cards--fjnuL {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 20px;
}

    @media screen and (max-width: 1023px) {.CardSelectorStage__cards--fjnuL {
        display: none
}
    }

.CardSelectorStage__card--BDvXd {
    width: 100%;
}

.CardSelectorStage__cardImage--OlVpH {
    width: 100%;
    height: auto;
    max-width: 200px;
    margin: 0 auto;
    aspect-ratio: 0.64;
    border-radius: 6px;
    margin-bottom: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/CardSelectorStage/CardSelectorStage.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,qCAAqC;IACrC,cAAc;AAKlB;;IAHI,uCANJ;QAOQ;AAER;IADI;;AAGJ;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":[".cards {\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    grid-gap: 20px;\n\n    @media (--mobile) {\n        display: none;\n    }\n}\n\n.card {\n    width: 100%;\n}\n\n.cardImage {\n    width: 100%;\n    height: auto;\n    max-width: 200px;\n    margin: 0 auto;\n    aspect-ratio: 0.64;\n    border-radius: 6px;\n    margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cards": `CardSelectorStage__cards--fjnuL`,
	"card": `CardSelectorStage__card--BDvXd`,
	"cardImage": `CardSelectorStage__cardImage--OlVpH`
};
export default ___CSS_LOADER_EXPORT___;
